

































































import { defineComponent } from '@vue/composition-api';
import HCard from '@/ui/components/base/HCard.vue';
import HForm from '@/ui/components/base/HForm.vue';
import HButton from '@/ui/components/base/HButton.vue';
import HTextField from '@/ui/components/base/HTextField.vue';
import HFileInput from '@/ui/components/base/HFileInput.vue';
import HToast from '@/ui/components/base/HToast.vue';

import useI18n from '@/ui/composables/base/use-i18n';
import useProfileEditVariables from '@/ui/composables/profile-edit/use-profile-edit-variables';
import useProfileEditTexts from '@/ui/composables/profile-edit/use-profile-edit-texts';
import useProfileEditRules from '@/ui/composables/profile-edit/use-profile-edit-rules';
import useProfileEditFunctions from '@/ui/composables/profile-edit/use-profile-edit-functions';
import useFormRules from '@/ui/composables/base/use-form-rules';

export default defineComponent({
  name: 'ProfileEditForm',
  components: {
    HForm,
    HCard,
    HButton,
    HTextField,
    HFileInput,
    HToast,
  },
  setup(_, { root, refs }) {
    const i18n = useI18n(root);
    const profileEditVariables = useProfileEditVariables();
    const profileEditTexts = useProfileEditTexts(i18n);
    const profileEditRules = useProfileEditRules(useFormRules(i18n), profileEditTexts);
    const { getText } = useI18n(root);
    const profileEditFunctions = useProfileEditFunctions({
      $store: root.$store,
      profileEditVariables,
      $refs: refs,
      getText,
    });
    return {
      ...profileEditVariables,
      ...profileEditTexts,
      ...profileEditRules,
      ...profileEditFunctions,
    };
  },
});
